module.exports = __webpack_public_path__ + "img/symbol_6.d04a3953.png";